// extracted by mini-css-extract-plugin
module.exports = {"h1":"Text_h1__3RD13","label":"Text_label__3rl3E"};